import React, { useState } from 'react';
import './Footer.scss';
import Logo from '../../../pages/ReportWizard/PDFSVG/Logo';
import { ReactComponent as PartsolLogo } from '../../../assets/svg/Partsol.svg';
import SupportModal from '../../../library/components/SupportModal/SupportModal';
import { selectLoggedInUser } from '../../slices/authSlice';
import { useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';

const Footer: React.FC = () => {
    const [isSupportModalOpen, setSupportModalOpen] = useState(false);
    const userDetails = useSelector(selectLoggedInUser);
    const userEmail = userDetails?.email;
    const userName = userDetails?.name;
    

    const handleSupportClick = () => {
        setSupportModalOpen(true);
    };

    return (
        <div className="footer-wrapper">
            <div className="footer-content">
                <div className="footer-left">
                <PartsolLogo style={{ width: '100px', height: 'auto', display: 'block'}}/>
                </div>
                <div className="footer-right">
                    {/* <nav className="footer-nav">
                        <a href="https://partsol.com/about/" target="_blank" rel="noopener noreferrer">About</a>
                        <a href="https://partsol.com/resources/careers/" target="_blank" rel="noopener noreferrer">Careers</a>
                        <a href="https://partsol.com/terms/" target="_blank" rel="noopener noreferrer">Terms of Service</a> */}
                    {/* </nav> */}
                    <Tooltip 
                        title="Contact our support team for assistance"
                        placement="top"
                        arrow
                    >
                        <button className="support-button" onClick={handleSupportClick}>
                            <span className="question-mark">?</span>
                            Support
                        </button>
                    </Tooltip>
                    <span className="copyright">© {new Date().getFullYear()} Copyright Partnership Solutions International</span>
                </div>
            </div>
            <SupportModal
                open={isSupportModalOpen}
                onClose={() => setSupportModalOpen(false)}
                sx={{ zIndex: (theme: any) => theme.zIndex.modal + 2 }}
            />
        </div>
    );
};

export default Footer;
